import { BottomSheetModal } from '@gorhom/bottom-sheet';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import theme from 'shared/styles/theme';

interface DisclosureBottomSheetProps {
  bottomSheetRef: RefObject<BottomSheetModal | null> | null;
  isDisclosurePresented: boolean;
  disclosureData?: string;
}

const DisclosureBottomSheet = ({
  disclosureData,
  bottomSheetRef,
  isDisclosurePresented,
}: DisclosureBottomSheetProps) => {
  const { t: translatedText } = useTranslation('home', {
    keyPrefix: 'progressTracker',
  });

  useViewDidFocusScreenAnalyticsEvent(
    isDisclosurePresented
      ? {
          key: '/onboardingChecklistDisclosuresNotification',
        }
      : null,
  );

  const disclosureDoneAnalytics = usePressableAnalytics({
    analyticsId: 'onboardingDisclosuresRead',
  });
  const dismissBottomSheet = () => {
    disclosureDoneAnalytics();
    bottomSheetRef?.current?.dismiss();
  };
  return (
    <BottomSheet ref={bottomSheetRef}>
      <View style={styles.bottomSheet} testID="disclosure-bottom-sheet">
        <TitleMdText numberOfLines={0}>
          {translatedText('disclosureLink')}
        </TitleMdText>

        <View style={styles.bottomSheetDisclosure}>
          <BodyBaseText key="disclosureOne" testID="disclosure-text">
            {disclosureData}
          </BodyBaseText>
        </View>

        <View style={styles.doneButton}>
          <Button
            label={translatedText('done')}
            onPress={dismissBottomSheet}
            size="LARGE"
            type="PRIMARY"
            width="FULL"
          />
        </View>
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  bottomSheet: {
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
  },
  bottomSheetDisclosure: {
    gap: theme.spacing.m,
    paddingBottom: theme.spacing.xl,
    paddingTop: theme.spacing.s,
  },
  doneButton: {
    paddingVertical: theme.spacing.m,
  },
});

export default DisclosureBottomSheet;
